import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {MiniPricerDlgComponent} from './component/mini-pricer-dlg/mini-pricer-dlg.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  bsModalRef: BsModalRef;

  title = 'mini-pricer';
  mode = 'SEARCH';

  constructor(private modalService: BsModalService) {

  }


  openDlg() {
    const initialState: any = {};
    this.bsModalRef = this.modalService.show(MiniPricerDlgComponent,
      {
        class: 'modal-lg',
        animated: true,
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
        initialState
      }
    );
  }


  ngOnInit(): void {
  }


  modeOut($event: any) {
    this.mode = $event;
  }

  close() {
    this.bsModalRef.hide();
  }
}
